import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import Youtube from "./Youtube.png";
import Instagram from "./Instagram.png";
import Facebook from "./Facebook.png";
import Twitter from "./Twitter.png";
import Ico11 from "./ico_11.png";

export class SocialView extends React.Component {
  static propTypes = {
    customclass: PropTypes.string.isRequired,
    children: PropTypes.any
  };

  /*
  // BRASIL
  <a href='https://www.youtube.com/playlist?list=PL1eAOVgexOL8GgaRIOcRTTHjBByAv-8FM' target='_blank'>
        <img title='Youtube' src={Youtube} />
      </a>
      <a href='https://www.instagram.com/festadocinemaitalianobrasil' target='_blank'>
        <img title='Instagram' src={Instagram} />
      </a>
      <a href='https://www.facebook.com/festadocinemaitalianobrasil' target='_blank'>
        <img title='Facebook' src={Facebook} />
      </a>
  */

  //<img title="Newsletter" src={Ico11} />
  render() {
    // console.log('SOCIAL this.props', this.props)
    if (this.props.children) {
      return (
        <div className={`social-view row ${this.props.customclass}`}>
          <div className="col-md-12">
            <div className="col-xs-12 col-md-6 text-left no-pad">
              {this.props.children}
            </div>
            <div className="wrp col-md-6">
              <p>siga-nos em: </p>
              <div>
                <a
                  href="https://www.youtube.com/user/8emeioFCI/featured?disable_polymer=1"
                  target="_blank"
                >
                  <img title="Youtube" src={Youtube} />
                </a>
                <a
                  href="https://www.instagram.com/festadocinemaitaliano"
                  target="_blank"
                >
                  <img title="Instagram" src={Instagram} />
                </a>
                <a
                  href="https://www.facebook.com/festadocinemaitaliano"
                  target="_blank"
                >
                  <img title="Facebook" src={Facebook} />
                </a>
                <a href="http://twitter.com/8emeio" target="_blank">
                  <img title="Twitter" src={Twitter} />
                </a>
                <Link to="/newsletter">
                  <div className="btn-to-newsletter" style={{ marginTop: -20 }}>
                    <div className="footnote">
                      <p className="lbl" style={{ lineHeight: "14px" }}>
                        Newsletter
                      </p>
                    </div>
                    <p className="btn-title">Receba a nossa newsletter</p>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={`social-view row ${this.props.customclass}`}>
        <div className="col-md-12 text-right">
          <p>siga-nos em: </p>
          <div>
            <a href="https://www.youtube.com/user/8emeioFCI" target="_blank">
              <img title="Youtube" src={Youtube} />
            </a>
            <a
              href="https://instagram.com/festadocinemaitaliano"
              target="_blank"
            >
              <img title="Instagram" src={Instagram} />
            </a>
            <a
              href="https://www.facebook.com/festadocinemaitaliano"
              target="_blank"
            >
              <img title="Facebook" src={Facebook} />
            </a>
            <a href="http://twitter.com/8emeio" target="_blank">
              <img title="Twitter" src={Twitter} />
            </a>
          </div>
        </div>
      </div>
    );
  }

  /*
  render () {
    // console.log('SOCIAL this.props', this.props)
    if (this.props.children) {
      return (
        <div className={`social-view row ${this.props.customclass}`}>
          <div className='col-md-12'>
            <div className='col-xs-12 col-md-6 text-left no-pad'>
               {this.props.children}
            </div>
            <div className='col-md-6 text-right'>
              <p>siga-nos em: </p>
              <div>
                <a href='https://www.youtube.com/user/8emeioFCI' target='_blank'>
                  <img title='Youtube' src={Youtube} />
                </a>
                <a href='https://instagram.com/festadocinemaitaliano' target='_blank'>
                  <img title='Instagram' src={Instagram} />
                </a>
                <a href='https://www.facebook.com/festadocinemaitaliano' target='_blank'>
                  <img title='Facebook' src={Facebook} />
                </a>
                <a href='http://twitter.com/8emeio' target='_blank'>
                  <img title='Twitter' src={Twitter} />
                </a>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className={`social-view row ${this.props.customclass}`}>
        <div className='col-md-12 text-right'>
          <p>siga-nos em: </p>
          <div>
            <a href='https://www.youtube.com/user/8emeioFCI' target='_blank'>
              <img title='Youtube' src={Youtube} />
            </a>
            <a href='https://instagram.com/festadocinemaitaliano' target='_blank'>
              <img title='Instagram' src={Instagram} />
            </a>
            <a href='https://www.facebook.com/festadocinemaitaliano' target='_blank'>
              <img title='Facebook' src={Facebook} />
            </a>
            <a href='http://twitter.com/8emeio' target='_blank'>
              <img title='Twitter' src={Twitter} />
            </a>
          </div>
        </div>
      </div>
    )
  }
*/
}



// WEBPACK FOOTER //
// ./src/views/SocialView/SocialView.js